module.exports = __webpack_public_path__ + "img/navLeftTop.798abe80.png";